if (!customElements.get('frigg-collection-toolbar')) {
  class FriggCollectionToolbar extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.filterMenus = Array.from(this.querySelectorAll('.frigg-collection-toolbar__filters > details'));

      this.filterMenus.forEach((menu) => {
        menu.addEventListener(
          'toggle',
          () => {
            if (!menu.open) return;

            this.filterMenus.forEach((otherMenu) => {
              if (otherMenu !== menu) otherMenu.open = false;
            });
          },
          { signal }
        );
      });

      this.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape') return;

          const openMenu = this.filterMenus.find((menu) => menu.open);
          if (!openMenu) return;

          openMenu.open = false;
          openMenu.querySelector('summary')?.focus();
        },
        { signal }
      );

      document.addEventListener(
        'pointerdown',
        (event) => {
          if (this.contains(event.target)) return;
          this.filterMenus.forEach((menu) => {
            menu.open = false;
          });
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  }

  customElements.define('frigg-collection-toolbar', FriggCollectionToolbar);
}
